import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "light", toggle: () => {} });

export const ThemeProvider = ({ children }) => {
    // Light is the default theme (EasiLinked design system; EP-001 v1.1 D20). It starts as
    // "light" to match the prerendered HTML, so hydration lines up; a saved preference is
    // applied right after. public/theme-init.js applies the saved class before first paint,
    // so a visitor who chose dark sees no flash.
    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const stored = localStorage.getItem("el-theme");
        const initial = stored || "light";
        setTheme(initial);
        document.documentElement.classList.toggle("dark", initial === "dark");
    }, []);

    const toggle = () => {
        setTheme((prev) => {
            const next = prev === "dark" ? "light" : "dark";
            document.documentElement.classList.toggle("dark", next === "dark");
            localStorage.setItem("el-theme", next);
            return next;
        });
    };

    return (
        <ThemeContext.Provider value={{ theme, toggle }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
